<template>
    <div class="periodical" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd" :style="{backgroundImage: 'url(' + background + ')'}">
        <topbar ref="topbar" :music="music" @musicClick="onMusicClick"/>
        <div class="turnbook" ref="book" :style="{top: top + 'px', left: left + 'px', width: width + 'px', height: height + 'px'}">
            <div v-for="(page, i) in pages" :key="i" class="page">
                <div class="picture" :style="{backgroundImage: 'url(' + page +')'}"></div>
            </div>
        </div>
        <thickness v-show="display== 'single' || bygone > 1" :count="thickness" style="position: absolute" :style="{ top: top + 'px', left: left + width + 'px', height: height + 'px' }"/>
        <bottombar v-model="current" :max="pages.length" :step="step" :marked="marked" @mark="onMark" class="bottombar"/>
        <div v-show="percent != 100" class="progressview">
            <i-circle :percent="percent" class="progressbar" style="color: white;">
                <div style="text-align: center;">
                    加载中
                </div>
                <div>
                    <span>{{percent}}</span>
                    <span>%</span>
                </div>
            </i-circle>
        </div>
        <audio ref="music" :src="audioSrc" preload="auto" loop="loop"></audio>
        <Drawer v-model="marked" placement="left" title="书签" class="bookmark">
            <div v-for="(mark, i) in bookmark" :key="i" @click="toMark(mark)" class="mark">
                <span class="text">{{mark.text}}</span>
                <span class="index">{{mark.page}}</span>
            </div>
        </Drawer>
    </div>
</template>

<script>
import {BASE_URL} from '../variables/base';
import topbar from '../components/topbar.vue';
import thickness from '../components/thickness.vue';
import bottombar from '../components/bottombar.vue';

export default {
    components: {
        topbar,
        thickness,
        bottombar,
    },
    data() {
        return {
            pages: [],
            title: '',
            cover: '',
            background: '',
            bookmark: [],
            bygone: 0,
            top: 0,
            left: 8,
            width: 100,
            height: 100,
            display: 'single',
            current: 1,
            step: 1,
            loaded: 0,
            inited: false,
            music: true,
            audioSrc: 'http://img.85804669.com/books/part/music.mp3',
            touch: {
                id: null,
                startX: 0,
                startY: 0
            },
            marked: false,
        };
    },
    computed: {
        thickness() {
            let length = this.pages.length || 1;
            return Math.ceil(Math.floor((1 - this.bygone / length) * 10));
        },
        percent() {
            let count = this.pages.length || 1;
            let value = Math.ceil(this.loaded / count * 100);
            if (!this.inited && value > 1) value--;
            return value;
        }
    },
    watch: {
        current(index) {
            let book = window.$(this.$refs.book);
            book.turn('page', index);
        }
    },
    methods: {
        /**
         * 初始化书刊。
         * 
         */
        init() {
            this.width = this.$el.clientWidth - 18;
            this.height = this.width * 1.366;
            this.display = 'single';
            this.step = 1;
            if (window.screen.width > 600) {
                this.height = this.$el.clientHeight * 0.8;
                this.width = this.height / 1.366 * 2;
                this.display = 'double';
                this.step = 2;
                this.left = (this.$el.clientWidth - this.width) / 2;
            }
            this.top = (this.$el.clientHeight - this.height) / 2;
            let book = window.$(this.$refs.book);
            book.turn({
                width: this.width,
                height: this.height,
                autoCenter: true,
                page: 1,
                display: this.display,
                when: {
                    turning: (event, page) => {
                        // 翻页时换上高清图片。
                        this.bygone = page;
                        this.current = page;
                        let index = page - 1;
                        this.resetImage(index);
                        // 如果有上一张，换高清图。
                        this.resetImage(index - 1);
                        // 如果有下一张，换高清图。
                        this.resetImage(index + 1);
                    }
                }
            });
            this.inited = true;
        },

        /**
         * 重设图片分辨率URL。
         * 
         */
        resetImage(index) {
            if (0 <= index && index < this.pages.length) {
                let image = new Image();
                let url = this.pages[index].split('?')[0] + '?x-oss-process=image/resize,w_1024';
                image.onload = () => {
                    this.$set(this.pages, index, url);
                };
                image.src = url;
            }
        },

        /**
         * 点击音乐按钮。
         * 
         */
        onMusicClick(value) {
            this.music = value;
            if (value) {
                this.$refs.music.play();
            } else {
                this.$refs.music.pause();
            }
        },

        /**
         * 微信初始化，分享设置。
         * 
         */
        initWx() {
            this.wxCall([
                'checkJsApi','onMenuShareTimeline','onMenuShareAppMessage'
            ]).then(() => {
                let link = window.location.href;
                let imgUrl = this.cover;
                window.wx.onMenuShareTimeline({
                    title: '《' + this.title + '》',
                    link: link,
                    imgUrl: imgUrl,
                });
                window.wx.onMenuShareAppMessage({
                    title: '《' + this.title + '》', // 分享标题
                    desc: '《' + this.title + '》', // 分享描述
                    link: link,
                    imgUrl: imgUrl,
                    type: 'link',
                    dataUrl: '',
                });
            });
        },

        /**
         * 触摸翻页。
         * 
         */
        onTouchStart(e) {
            if (null !== this.touch.id) return;
            var touch = e.targetTouches[0];
            this.touch.id = touch.identifier;
            this.touch.startX = touch.pageX;
            this.touch.startY = touch.pageY;
        },
        onTouchMove() {},
        onTouchEnd(e) {
            if (null === this.touch.id) return;
            var touch = this.getCurrentTouch(e.changedTouches);
            if (null === touch) return;
            this.touch.id = null;
            var diffX = this.touch.startX - touch.pageX;
            var diffY = this.touch.startY - touch.pageY;
            if (Math.abs(diffY) > 50) return;
            let book = window.$(this.$refs.book);
            if (diffX < -50) {
                book.turn('previous');
            }
            if (diffX > 50) {
                book.turn('next');
            }
        },
        getCurrentTouch(touches) {
            for (var i = 0; i < touches.length; ++i) {
                if (this.touch.id == touches[i].identifier) {
                    return touches[i];
                }
            }
            return null;
        },

        /**
         * 
         */
        onMark(able) {
            this.marked = able;
        },
        toMark(mark) {
            this.current = mark.page;
        },
    },
    mounted() {
        let url = BASE_URL + '/Book/Content/index';
        let load = this.ajaxPost(url, {
            name: this.$route.query.name,
        }).then(response => {
            response.data.pages.forEach(page => {
                this.pages.push(page + '?x-oss-process=image/resize,h_32');
            });
            this.pages[0] = this.pages[0].split('?')[0] + '?x-oss-process=image/resize,w_1024';
            this.title = response.data.name;
            this.cover = response.data.cover;
            this.audioSrc = response.data.music;
            this.background = response.data.background;
            this.bookmark = response.data.index;

            // 播放音乐操作。TODO...
            // document.addEventListener("WeixinJSBridgeReady", () => {
            //     this.$refs.music.play();
            // }, false);
 
            document.title = '《' + this.title + '》';
            this.preloadImage(this.pages, () => {
                this.loaded++;
            }).then(() => {
                this.loaded = this.pages.length;
            }).catch(() => {
                console.log('有图片加载失败。');
            });
            this.initWx();
        });
        Promise.all([load]).then(() => {
            this.importScript(BASE_URL + '/Book/Public/js/jquery.min.js').then(() => {
                this.importScript(BASE_URL + '/Book/Public/js/turn.min.js').then(() => {
                    this.init();
                });
            });
        });

        // 苹果微信下自动播放。
        document.addEventListener("WeixinJSBridgeReady", () => {
            this.$refs.music.play();
        }, false);
        this.$refs.music.play();
    },
    beforeRouteEnter(t, f, next) {
        next(() => {
            if (f.name == 'Bookshelves') {
                location.reload();
            }
        });
    }
}
</script>

<style lang="less">
.turnbook {
    overflow: visible !important;
    & > div:not(.page-wrapper):not(.shadow) {
        background: white;
        & > div > div {
            background: white;
        }
    }
}
.bookmark {
    .ivu-drawer-wrap {
        z-index: 3100;
    }
}
</style>


<style lang="less" scoped>
.periodical {
    overflow: hidden;
    position: relative;
    width: 100vw;
    height: 100vh;
    background-size: 300px;
    background-repeat: repeat;

}
.topbar {
    position: absolute;
    top: 3px;
    left: 0;
    right: 0;
}
.bottombar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 3px;
}
.turnbook {
    z-index: 1000;
    overflow: visible;

    .page {
        background-color: white;

        .picture {
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
            border: 1px solid #ddd;
        }

        &.p1 {
            &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 10;
                background-image: linear-gradient(90deg, rgba(17, 17, 17, 0.39), rgba(119, 119, 119, 0.027) 3%);
            }
        }

        &.odd {
            &:not(.p1) {
                border-top-left-radius: 6% 1%;
                border-bottom-left-radius: 6% 1%;

                &::after {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 10;
                    border-top-left-radius: 6% 1%;
                    border-bottom-left-radius: 6% 1%;
                    background-image: linear-gradient(90deg, rgba(17, 17, 17, 0.39), rgba(119, 119, 119, 0.027) 15%);
                }
                .picture {
                    border-top-left-radius: 6% 1%;
                    border-bottom-left-radius: 6% 1%;
                }
            }
        }
        &.even {
            border-top-right-radius: 6% 1%;
            border-bottom-right-radius: 6% 1%;
            &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 10;
                border-top-right-radius: 6% 1%;
                border-bottom-right-radius: 6% 1%;
                background-image: linear-gradient(270deg, rgba(17, 17, 17, 0.39), rgba(119, 119, 119, 0.027) 15%);
            }
            .picture {
                border-top-right-radius: 6% 1%;
                border-bottom-right-radius: 6% 1%;
            }
        }
    }
}

.progressview {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3000;
    justify-content: center;
    align-items: center;
    background: #17f;
}

.progressbar {
    
}
.touchpane {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000;
}

.bookmark {
    .mark {
        overflow: hidden;
        position: relative;
        height: 30px;
        line-height: 30px;
        font-size: 16px;

        &:active {
            background-color: #7bf;
        }
        
        .text {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
        }

        .index {
            position: absolute;
            top: .25em;
            right: .25em;
            bottom: .25em;
            font-size: 12px;
            color: #b93;
        }
    }
}
</style>
